// src/services/products.api.js
import { apiRequest } from "./api";

const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5005/api";

const readApiResponse = async (res, fallbackMessage) => {
  const contentType = res.headers.get("content-type") || "";

  if (contentType.includes("application/json")) {
    const data = await res.json();

    if (!res.ok) {
      throw new Error(data?.message || fallbackMessage);
    }

    return data;
  }

  const text = await res.text().catch(() => "");

  if (!res.ok) {
    throw new Error(
      `${fallbackMessage} (${res.status})`
    );
  }

  throw new Error(
    text?.startsWith("<!DOCTYPE")
      ? `${fallbackMessage}: server returned HTML instead of JSON`
      : fallbackMessage
  );
};

/**
 * Get all products (public)
 * Optional filters:
 *  - sale=true
 *  - bestseller=true
 *  - new=true
 */
export async function getAllProducts(filters = {}) {
  const qs = new URLSearchParams();

  Object.entries(filters).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    qs.set(k, String(v));
  });

  return apiRequest(`/products${qs.toString() ? `?${qs}` : ""}`);
}

/**
 * Get product details by SEO slug (public)
 * Backend route: GET /api/products/:slug
 */
export async function getProductBySlug(slug) {
  if (!slug) throw new Error("Missing product slug");

  const safeSlug = String(slug).trim();

  return apiRequest(`/products/${encodeURIComponent(safeSlug)}`);
}

export async function rateProduct(productId, rating) {
  if (!productId) throw new Error("Missing product id");

  const res = await fetch(`${API_URL}/products/${productId}/rating`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ rating }),
  });

  return readApiResponse(res, "Failed to submit rating");
}
